export enum RewardCoefficients {
  High,
  Medium,
  Low,
}
